export default __webpack_public_path__ + "static/media/_DSC0324.20e8b4b9.JPG";